module.exports = __webpack_public_path__ + "img/nissi_D.39992d09.jpg";